/**
 * Get difficulty label from difficulty value
 * @param difficulty - Difficulty value (0-5)
 * @returns Difficulty label string
 */
export const getDifficultyLabel = (difficulty?: number): string => {
  if (!difficulty || difficulty === 0) {
    return "-";
  }

  return `Level ${difficulty}`;
};

/**
 * Get section/module label based on exam type
 * @param examType - Exam type (SAT, ACT, AP, etc.)
 * @returns Section label string ("Module" for SAT, "Section" for others)
 */
export const getSectionLabel = (examType?: string): string => {
  return examType === "SAT" ? "Module" : "Section";
};
